import styled from "styled-components"
import { Link } from "gatsby"

export const FooterCTAContainer = styled(Link)`
  display: flex;
  justify-content: center;
  position: relative;
  margin-bottom: -100px;
  margin-top: ${({ marginTop }) => (marginTop ? "100px" : "0")};
  left: 0;
  width: 100%;
  background: #4c0ffb;
  padding: 60px;
  text-decoration: none;

  @media screen and (max-width: 1440px) {
    flex-direction: column;
  }

  @media screen and (max-width: 780px) {
    padding: 40px 20px;
    margin-top: ${({ marginTop }) => (marginTop ? "60px" : "0")};
  }
`

export const FooterCTAText = styled.div`
  font-size: 40px;
  line-height: 50px;
  color: #fff;
  font-weight: lighter;
  margin-right: 40px;
  text-align: center;

  & span {
    color: #9bf9ff;
    font-weight: bold;
  }

  @media screen and (max-width: 780px) {
    font-size: 36px;
    line-height: 46px;
    margin-right: 0px;
  }
`
export const FooterCTAButton = styled.div`
  ${({ theme: { typography } }) => typography.desktop.link};
  border-radius: 70px;
  border: 2px solid #fff;
  color: #fff;
  text-transform: uppercase;
  padding: 0 60px;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 70px;

  ${FooterCTAContainer}:hover & {
    background: #9bf9ff;
    color: #4c0ffb;
    border-color: #9bf9ff;
  }

  ${FooterCTAContainer}:focus-visible & {
    box-shadow: inset 0 0 0 2px #fff;
  }

  @media screen and (max-width: 1440px) {
    margin: auto;
    margin-top: 40px;
    padding: 0 60px;
  }

  @media screen and (max-width: 780px) {
    margin-top: 30px;
    padding: 0px;
    width: 100%;
  }
`
